import Edit from "./Edit.vue";
import Index from "./Index.vue";
import New from "./New.vue";
import Show from "./Show.vue";

export default [
  {
    path: "",
    name: "UsersMagazinesIndex",
    component: Index,
    meta: {
      title: "広報誌管理",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: "new",
    name: "UsersMagazinesNew",
    component: New,
    meta: {
      title: "新規作成",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        { title: "広報誌管理", name: "UsersMagazinesIndex" },
      ],
    },
  },
  {
    path: ":id",
    name: "UsersMagazinesShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        { title: "広報誌管理", name: "UsersMagazinesIndex" },
      ],
    },
  },
  {
    path: ":id/edit",
    name: "UsersMagazinesEdit",
    component: Edit,
    meta: {
      title: "編集",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        { title: "広報誌管理", name: "UsersMagazinesIndex" },
      ],
    },
  },
];
